import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class LoginAPI {

  static registration = (registration, success, failure) => {
    fetch(Config.app.link + 'registration', new Header('POST', registration))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static auth = (auth, success, failure) => {
    fetch(Config.app.link + 'auth/' + auth, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static login = (username, password, success, failure) => {
    const body = { username: username, password: password };
    fetch(Config.app.link + 'login', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static logout = (success, failure) => {
    fetch(Config.app.link + 'logout', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static regToken = (token, success, failure) => {
    const body = { token: token };
    fetch(Config.app.link + 'api/user/web-token', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default LoginAPI;